import { Text, Heading, Stack, Box } from 'braid-design-system';
import React from 'react';

import ImageCard from 'src/components/LegacyCarousel/components/ImageCard/ImageCard';

import * as styles from './style.css';

interface CarouselCardProps {
  title: string;
  url: string;
  imageUrl: string;
  description: string;
  htag: string;
}

const CarouselCard = (props: CarouselCardProps) => (
  <ImageCard {...props} cropImage={false}>
    <Stack space="medium">
      <Heading level="4" align="center">
        {props.title}
      </Heading>
      <Text align="center">
        {props.description}{' '}
        <Box className={styles.displayLink} component="span">
          Visit &gt;
        </Box>
      </Text>
    </Stack>
  </ImageCard>
);

export default CarouselCard;
